var _loggerToConsoleApiNa;

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { combine, ErrorSource, timeStampNow, originalConsoleMethods, globalConsole, ConsoleApiName } from '@datadog/browser-core';
import { HandlerType } from '../logger';
import { isAuthorized, StatusType } from './isAuthorized';
export function startLoggerCollection(lifeCycle) {
  function handleLog(logsMessage, logger, handlingStack, savedCommonContext, savedDate) {
    var messageContext = combine(logger.getContext(), logsMessage.context);

    if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
      displayInConsole(logsMessage, messageContext);
    }

    if (isAuthorized(logsMessage.status, HandlerType.http, logger)) {
      var rawLogEventData = {
        rawLogsEvent: {
          date: savedDate || timeStampNow(),
          message: logsMessage.message,
          status: logsMessage.status,
          origin: ErrorSource.LOGGER
        },
        messageContext: messageContext,
        savedCommonContext: savedCommonContext,
        ddtags: logger.getTags()
      };

      if (handlingStack) {
        rawLogEventData.domainContext = {
          handlingStack: handlingStack
        };
      }

      lifeCycle.notify(0
      /* LifeCycleEventType.RAW_LOG_COLLECTED */
      , rawLogEventData);
    }
  }

  return {
    handleLog: handleLog
  };
}
var loggerToConsoleApiName = (_loggerToConsoleApiNa = {}, _defineProperty(_loggerToConsoleApiNa, StatusType.ok, ConsoleApiName.debug), _defineProperty(_loggerToConsoleApiNa, StatusType.debug, ConsoleApiName.debug), _defineProperty(_loggerToConsoleApiNa, StatusType.info, ConsoleApiName.info), _defineProperty(_loggerToConsoleApiNa, StatusType.notice, ConsoleApiName.info), _defineProperty(_loggerToConsoleApiNa, StatusType.warn, ConsoleApiName.warn), _defineProperty(_loggerToConsoleApiNa, StatusType.error, ConsoleApiName.error), _defineProperty(_loggerToConsoleApiNa, StatusType.critical, ConsoleApiName.error), _defineProperty(_loggerToConsoleApiNa, StatusType.alert, ConsoleApiName.error), _defineProperty(_loggerToConsoleApiNa, StatusType.emerg, ConsoleApiName.error), _loggerToConsoleApiNa);

function displayInConsole(_ref, messageContext) {
  var status = _ref.status,
      message = _ref.message;
  originalConsoleMethods[loggerToConsoleApiName[status]].call(globalConsole, message, messageContext);
}